import { Stack, Typography } from '@mui/joy';
import { useTranslation } from 'react-i18next';

import { Confirmation } from 'core/components';
import { Color, Level } from 'theme/enums';

interface IProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  selectionCount: number;
}

export const DetachConfirmation = ({ isOpen, onConfirm, onCancel, selectionCount }: IProps) => {
  const { t } = useTranslation();

  const getConfirmationMessage = () => {
    return (
      <Stack gap={1}>
        <Typography>
          {t('messageConfirmDetachVendorQuotesFromProject', {
            count: selectionCount,
          })}
        </Typography>

        <Typography color={Color.DANGER} level={Level.BODY_SM} fontStyle={'italic'}>
          {t('messagePricingResetRequired')}
        </Typography>
      </Stack>
    );
  };

  return (
    <Confirmation
      isOpen={isOpen}
      color={Color.DANGER}
      title={t('titleDetachVendorQuotes', { count: selectionCount })}
      message={getConfirmationMessage()}
      confirmBtnLabel={t('buttonLabelDetach')}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
